import { FleekError } from './FleekError';

type Application = {
  id?: string;
  name?: string;
};

type ApplicationWhitelistDomainDuplicityErrorOptions = {
  application: Application;
  whitelistDomains: string[];
};

export class ApplicationWhitelistDomainDuplicityError extends FleekError<ApplicationWhitelistDomainDuplicityErrorOptions> {
  public name = 'ApplicationWhitelistDomainDuplicityError';

  toString = () => `Application ${this.data.application.name} doesn't have unique white label domains.`;
}
